'use client';

import { motion } from 'framer-motion';

const LoadingDot = () => {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <div className="flex space-x-2">
        <motion.div
          className="size-3 rounded-full bg-primary"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.6, 1, 0.6],
          }}
          transition={{
            duration: 1.1,
            ease: 'easeInOut',
            repeat: Infinity,
          }}
        />
        <motion.div
          className="size-3 rounded-full bg-primary"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.6, 1, 0.6],
          }}
          transition={{
            duration: 1.1,
            ease: 'easeInOut',
            repeat: Infinity,
            delay: 0.3,
          }}
        />
        <motion.div
          className="size-3 rounded-full bg-primary"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.6, 1, 0.6],
          }}
          transition={{
            duration: 1.1,
            ease: 'easeInOut',
            repeat: Infinity,
            delay: 0.6,
          }}
        />
      </div>
    </div>
  );
};

export default LoadingDot;
